// Unified studio colour system. One meaning per colour. Shared by the dashboard,
// the Task Details dialog and All Tasks so the app feels consistent.

export const STATUS_PILL = {
  overdue: { label: "Overdue", bg: "#FDECEC", text: "#B42318" },
  for_review: { label: "For Review", bg: "#FFF4D6", text: "#8A5A00" },
  update_requested: { label: "Update Requested", bg: "#FDE8DC", text: "#B34714" },
  checking: { label: "Checking", bg: "#EDE9FE", text: "#5B3CC4" },
  in_progress: { label: "In Progress", bg: "#E0F0FF", text: "#1A64BD" },
  assigned: { label: "Assigned", bg: "#EEF1F4", text: "#4A5563" },
  not_assigned: { label: "Not Assigned", bg: "#EEF1F4", text: "#4A5563" },
  completed: { label: "Completed", bg: "#E6F4EA", text: "#2E7D4F" },
};

// Task list group order (Overdue is a virtual, pinned group computed from due date).
// not_assigned is intentionally excluded — those tasks never appear on the dashboard.
export const GROUP_ORDER = ["for_review", "update_requested", "checking", "in_progress", "assigned"];
// Statuses a user can pick inline.
export const STATUS_CHOICES = ["not_assigned", "assigned", "in_progress", "checking", "for_review", "update_requested", "completed"];

export const PRIORITY_FLAG = {
  urgent: { label: "Urgent", color: "#D64545" },
  high: { label: "High", color: "#E8912D" },
  normal: { label: "Normal", color: "#3B82F6" },
  low: { label: "Low", color: "#A0A4AB" },
  none: { label: "None", color: "" },
};
export const PRIORITY_CHOICES = ["none", "low", "normal", "high", "urgent"];

export const ACTION_CARDS = [
  { key: "overdue", label: "Overdue", color: "#B42318", bg: "#FDECEC" },
  { key: "due_soon", label: "Due in 3 days", color: "#D99A1E", bg: "#FBF0D9" },
  { key: "for_review", label: "For Review", color: "#8A5A00", bg: "#FFF4D6" },
  { key: "update_requested", label: "Update Requested", color: "#B34714", bg: "#FDE8DC" },
  { key: "assigned", label: "Assigned", color: "#4A5563", bg: "#EEF1F4" },
  { key: "in_progress", label: "In Progress", color: "#1A64BD", bg: "#E0F0FF" },
];

export const FOLDER_TABS = [
  { key: "all_current", label: "All Current" },
  { key: "architecture_current", label: "Architecture Current" },
  { key: "architecture_completed", label: "Architecture Completed" },
  { key: "interior_current", label: "Interior Current" },
  { key: "interior_completed", label: "Interior Completed" },
];

// Folder tag styling by category.
export function folderTag(category) {
  if (category === "architecture_current") return { dot: "#2F5D62", bg: "#E6EFEF", text: "#2F5D62", label: "Architecture" };
  if (category === "architecture_completed") return { dot: "#8A8F8F", bg: "#F1F1EF", text: "#8A8F8F", label: "Architecture ·done" };
  if (category === "interior_current") return { dot: "#B5654A", bg: "#F6E9E4", text: "#B5654A", label: "Interior" };
  if (category === "interior_completed") return { dot: "#A58F86", bg: "#F1F1EF", text: "#A58F86", label: "Interior ·done" };
  return { dot: "#9A9893", bg: "#F1F1EF", text: "#6B6B66", label: "—" };
}

// Muted, harmonious avatar palette.
export const AVATAR_TONES = ["#2F5D62", "#B5654A", "#5B6C8F", "#7A8B5C", "#8E6C8A", "#C08A3E", "#4F7C9A", "#9C5E5E", "#5E8C7A", "#6B6B66"];
export function toneFor(id) {
  const s = String(id || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = s.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_TONES[Math.abs(h) % AVATAR_TONES.length];
}
